import { requestJson } from "../lib/http";
import type { AuthUser, LoginPayload, LoginResult } from "../types/auth";

export function login(payload: LoginPayload) {
  return requestJson<LoginResult>("/login/handler", {
    method: "POST",
    body: JSON.stringify({ platform: 1, version: 1, ...payload }),
    skipAuth: true
  });
}

export function getCurrentUser() {
  return requestJson<AuthUser>("/user/info?platform=1&version=1");
}

export function logout() {
  return requestJson<void>("/auth/logout", {
    method: "POST"
  });
}
